{
  "it": {
    "unit": {
      "actions": {
        "bulk": {
          "activate": "Attiva unità",
          "allow_customer_issue_creation": "Consenti ai clienti di creare segnalazioni",
          "block_customer_issue_creation": "Impedisci ai clienti di creare segnalazioni",
          "deactivate": "Disattiva unità",
          "give_access": "Concedi accesso ai clienti",
          "revoke_access": "Revoca accesso ai clienti"
        },
        "go_to_unit": "Vai all'unità",
        "revokeAccess": "Revoca accesso",
        "select": "Selezioni il tipo",
        "selectOutdoorCategory": "Selezioni lo spazio esterno",
        "selectUnit": "Selezioni un'unità",
        "setCustomer": "Assegna un cliente a",
        "setVisible": "Concedi accesso",
        "submit": "Salva",
        "update_pricing": "Aggiorna prezzi",
        "add_email": "Aggiungi email",
        "retry_skipped": "Riprova a concedere l’accesso",
        "finish_access": "Fatto"
      },
      "attributes": {
        "address_city": "Città",
        "address_country": "Paese",
        "address_number": "Numero civico",
        "address_street": "Via",
        "address_zip": "CAP",
        "amount": "Importo",
        "bathrooms": "Numero di bagni",
        "bedrooms": "Numero di camere da letto",
        "category": "Tipo",
        "category_outdoor": "Spazio esterno",
        "customer": "Cliente",
        "deed_signed_at": "Data di scambio dei contratti",
        "description": "Descrizione",
        "electricity": "Elettricità",
        "floor": "Piano",
        "house_subcategory": "Tipologia abitativa",
        "internal_note": "Nota interna dell'unità",
        "meter_number": "Numero contatore",
        "meter_number_electricity": "Numero contatore elettricità",
        "meter_number_gas": "Numero contatore gas",
        "meter_number_warmth": "Numero contatore riscaldamento",
        "meter_number_water": "Numero contatore acqua",
        "meter_numbers": "Numeri contatori",
        "name": "Nome",
        "orientation": "Orientamento",
        "price_value": "Valore totale di vendita",
        "price_value_construction": "Valore di costruzione",
        "price_value_construction_existing": "Costi della costruzione esistente",
        "price_value_fees": "Onorari di architettura/ingegneria",
        "price_value_land": "Valore del terreno",
        "quotity": "Quotità di trasferimento",
        "sales_employee": "Responsabile vendite",
        "surface_garden": "Superficie giardino",
        "surface_terrace": "Superficie terrazza",
        "surface_total": "Superficie totale",
        "tax_percentage": "% Tasse",
        "toilets": "Numero di servizi igienici",
        "total": "Totale",
        "vat_percentage": "% IVA"
      },
      "house_subtype": {
        "detached": "Casa indipendente",
        "rowhouse": "Casa a schiera",
        "semidetached": "Casa bifamiliare"
      },
      "labels": {
        "access_skipped_without_email": "{count} accesso saltato perché il cliente non ha un indirizzo email. | {count} accessi saltati perché i clienti non hanno un indirizzo email.",
        "activate": "Attiva",
        "address": "Indirizzo",
        "areYouSureDeactivate": "È sicuro di voler disattivare {unit_name}?",
        "bathrooms": "bagno | bagni",
        "bedrooms": "camera da letto | camere da letto",
        "cannot_activate_all_units": "Non ha abbastanza unità rimanenti per attivare tutte le unità selezionate",
        "customer_can_create_issue_project_off": "Disattivato per l'intero progetto nelle impostazioni del progetto.",
        "customer_issue_creation_unit_off": "Non puoi più inviare segnalazioni per questa unità.",
        "deactivate": "Disattiva",
        "deactivateMessage": "Il cliente potrà comunque comunicare con Lei e continuerà ad avere accesso a tutte le proprie informazioni. Altre azioni come la creazione di decisioni, il caricamento di documenti o l'invio di questionari per {unit_name} non saranno tuttavia più possibili.",
        "deactivated": "Disattivato",
        "notAvailableDeactivated": "Non disponibile per un'unità disattivata",
        "deedSignedOn": "Contratti firmati il {date}",
        "deedWillBeSignedOn": "I contratti verranno firmati il {date}",
        "detailed_price": "Dettagliato",
        "details": "Dettagli",
        "email_address_secondary_delivery_content": "riceve le email di notifica come ex contatto secondario",
        "email_address_secondary_delivery_tip": "Questo cliente è stato originariamente aggiunto come contatto secondario dell'altro cliente, prima che fosse introdotto il supporto per più clienti per unità: questo cliente continuerà a ricevere le stesse email di notifica dell'altro cliente, tuttavia solo l'altro cliente ha accesso all'unità/al login.",
        "existingVatValues": "Alcuni valori IVA sono diversi da 0",
        "export": "Esporta",
        "export_preparing": "La raccolta dei dati dell'unità potrebbe richiedere alcuni secondi.",
        "facing": "Esposto a {direction}",
        "fromATotal": "Totale progetto: {total}",
        "general": "Generale",
        "howDoesCustomerSeeThis": "Come vede il cliente la propria unità?",
        "integrationNoCustomerAssigned": "Nessun cliente assegnato, assegni il cliente in {integration_name}.",
        "internal": "Interno",
        "internalDisclaimer": "Queste informazioni sono visibili solo al Suo team",
        "invitationAddEmailAddress": "Per concedere a {customer} l'accesso all'unità, inserisca prima l'indirizzo email nella pagina dei contatti del cliente.",
        "invitationAddEmailAddress_SUP": "Per concedere a {customer} l'accesso al progetto, inserisca prima l'indirizzo email nella pagina dei contatti del cliente.",
        "invitationSentTo": "{customer} riceverà a breve il proprio invito all'indirizzo {email}",
        "maintainerNoCustomerAssigned": "Nessun cliente assegnato, solo i membri del team con ruolo 'Proprietario' possono assegnare un cliente a un'unità.",
        "more": "altri",
        "onFloor": "Al piano",
        "or_create_new": "Oppure crea nuovo",
        "other_units": "Ha altre unità",
        "price_view": "Vista prezzo",
        "sales_value": "Tutti i prezzi sono in {currency}",
        "scopes": {
          "invisible": "Nessun accesso all'unità",
          "invisible_SUP": "Nessun accesso al progetto",
          "visible": "Ha accesso",
          "visible_SUP": "Ha accesso"
        },
        "scopes_description": {
          "invisible": "Il cliente non ha ancora accesso a questa unità nel portale cliente",
          "invisible_SUP": "Il cliente non ha ancora accesso a questo progetto nel portale cliente",
          "visible": "Il cliente ha accesso a questa unità nel portale cliente",
          "visible_SUP": "Il cliente ha accesso a questa unità nel portale cliente"
        },
        "search_unit": "Cerca unità o cliente...",
        "selectUnit": "Selezioni un'unità",
        "select_contact_required": "Selezioni prima un contatto",
        "select_existing_contact": "Esistente",
        "set_unit_price": "Imposta prezzo unità",
        "showUnit": "Mostra unità",
        "simple_price": "Semplice",
        "toggleDetailedPrice": "Cambia vista prezzo",
        "unassigned": "Nessun cliente assegnato",
        "unit": "Nessuna unità | Una unità | {count} unità",
        "unitLabel": "Unità",
        "units": "Unità",
        "units_assigned_count": "{assigned} / {total} unità",
        "units_not_added": "{count} unità non ancora aggiunta | {count} unità non ancora aggiunte",
        "utilities": "Utenze",
        "visibleCustomer": "Questa informazione è visibile ai clienti",
        "access_no_changes": "Non è stato concesso alcun nuovo accesso.",
        "access_invitation_notice": "I nuovi clienti riceveranno un invito via email. I clienti già invitati non riceveranno un altro invito.",
        "access_skipped_instructions": "Aggiunga gli indirizzi email mancanti nei profili dei clienti, poi torni qui e riprovi. I profili si aprono in una nuova scheda.",
        "access_skipped_owner_instructions": "Solo i proprietari possono aggiornare gli indirizzi email. Chieda a un proprietario di aggiungere gli indirizzi mancanti, poi provi di nuovo a concedere l’accesso.",
        "access_skipped_empty": "Nessun accesso saltato.",
        "access_skipped_reason": "Email mancante",
        "access_granted_customers": "Accesso concesso a {count} cliente. | Accesso concesso a {count} clienti."
      },
      "outdoor_category": {
        "balcony": "Balcone",
        "garden": "Giardino",
        "null": "Nessuno",
        "terrace": "Terrazza",
        "terrace_garden": "Terrazza + Giardino"
      },
      "status": {
        "unavailable": "Non disponibile"
      },
      "toasts": {
        "activateSuccess": "{unit_name} è stata attivata con successo",
        "create_fixed": "Unità creata",
        "create_rundle": "Nuova unità attiva creata. Rimane {count} unità attiva. | Nuova unità attiva creata. Rimangono {count} unità attive.",
        "deactivateSuccess": "{unit_name} è stata disattivata con successo",
        "delete": "Unità eliminata",
        "update": "Unità aggiornata"
      },
      "type": {
        "alf": "Residenza assistita",
        "apartment": "Appartamento",
        "cellar": "Cantina",
        "commercial": "Commerciale",
        "duplex": "Duplex",
        "house": "Casa",
        "loft": "Loft",
        "office": "Ufficio",
        "penthouse": "Attico",
        "sme": "Unità PMI",
        "studio": "Monolocale"
      },
      "validation": {
        "needName": "Il titolo è obbligatorio",
        "needNumber": "Deve essere un numero (ad es. 85)",
        "pricesNotUpdatable": "Alcuni o tutti i prezzi sono stati utilizzati per le rate e non possono quindi essere modificati. Rimuova le rate associate per modificare nuovamente i prezzi",
        "totalSalesValueNotEqualToParts": "Sembra che il valore totale di vendita non sia uguale alla somma delle sue parti"
      }
    }
  }
}
